import { format, type Locale, type Strings, type Vars } from "../i18n";

// Helpers for the parent components. They take `locale` as a prop (the parent app may
// show a child's data in the parent's own language), so they translate without context.

export function translator<K extends string>(
  strings: Strings<K>,
  locale: Locale,
): (key: K, vars?: Vars) => string {
  return (key, vars) => format(locale, strings[locale][key], vars);
}

/** A 0..1 engine value clamped into range; NaN and infinities give null. */
export function unit(value: number | null): number | null {
  if (value === null || !Number.isFinite(value)) return null;
  return Math.min(1, Math.max(0, value));
}

/** Whole percent of a 0..1 value, formatted for the locale ("62%", "62 %"). */
export function percent(locale: Locale, fraction: number): string {
  return new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 0 }).format(
    Math.round(fraction * 100) / 100,
  );
}

/** Picks the plural form of `count` for the locale ("one" or "other"). */
export function pluralForm(locale: Locale, count: number): "one" | "other" {
  return new Intl.PluralRules(locale).select(count) === "one" ? "one" : "other";
}
